
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"cls-1",attrs:{"cx":"75","cy":"77.12","r":"57.88"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M63.85 110.44V81.5H82.5v28.94h39.81a58.33 58.33 0 01-15.83 15.25l-1.44.91c-1 .59-2 1.15-3 1.69q-.75.41-1.53.78l-1.55.74-1.45.64-.13.05c-.53.22-1.06.44-1.6.64s-1.08.41-1.62.6-1.1.38-1.65.55l-1.41.43-.56.16-1.39.37c-.56.14-1.13.28-1.7.4s-1.29.27-1.94.39l-.94.17-.78.12c-1 .16-2 .29-3 .38l-1 .1h-.46l-1.24.08c-1 .05-2 .08-3 .08s-2 0-3-.08l-1.24-.08h-.46l-1-.1c-1-.09-2-.22-3-.38l-.78-.12-.94-.17a55.427 55.427 0 01-3.64-.79l-1.39-.37-.56-.16-1.41-.43a53.147 53.147 0 01-3.27-1.15c-.54-.21-1.07-.42-1.6-.64l-.13-.05-1.67-.64-1.55-.74q-.78-.37-1.53-.78c-1-.54-2-1.1-3-1.69l-1.44-.91a58.33 58.33 0 01-15.83-15.25h36.2"}})])
          )
        }
      }
    